module.exports = __webpack_public_path__ + "img/invitation AMMIRP-01.9894c74d.jpg";